/* eslint-disable */
export default {
  header: 'Desativar monitorização de erros',
  content:
    'Desativar o modo de monitorização de erros eliminará todos os registos de erros atuais. Deseja continuar?',
  confirm: 'Desativar',
  cancel: 'Cancelar',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
